export default __webpack_public_path__ + "static/media/bbva.769b0247.png";